/* Elin Perfumes — reviews carousel.
 *
 * Pages through review cards a screenful at a time, advancing on its own and
 * on arrow/dot input. Autoplay pauses on hover, on keyboard focus, and while
 * the section is off screen, and stays off entirely for reduced-motion users.
 */
(() => {
  const AUTOPLAY_MS = 6000;

  document.querySelectorAll('[data-elin-carousel]').forEach((root) => {
    const track = root.querySelector('[data-elin-track]');
    const slides = [...root.querySelectorAll('[data-elin-slide]')];
    const dotsHost = root.querySelector('[data-elin-dots]');
    if (!track || slides.length < 2) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let page = 0;
    let pageCount = 1;
    let timer = null;
    let paused = false;
    let visible = true;

    const perPage = () => {
      const slideWidth = slides[0].getBoundingClientRect().width;
      if (!slideWidth) return 1;
      return Math.max(1, Math.round(track.getBoundingClientRect().width / slideWidth));
    };

    const buildDots = () => {
      if (!dotsHost) return;
      dotsHost.replaceChildren();
      for (let i = 0; i < pageCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'elin-carousel__dot';
        dot.setAttribute('aria-label', `Go to review page ${i + 1} of ${pageCount}`);
        dot.addEventListener('click', () => go(i, true));
        dotsHost.appendChild(dot);
      }
    };

    const paint = () => {
      const target = slides[Math.min(page * perPage(), slides.length - 1)];
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: reduced ? 'instant' : 'smooth' });
      if (dotsHost) {
        [...dotsHost.children].forEach((d, i) => d.classList.toggle('is-active', i === page));
      }
    };

    const go = (next, user) => {
      page = (next + pageCount) % pageCount;
      paint();
      if (user) restart();
    };

    const measure = () => {
      const next = Math.max(1, Math.ceil(slides.length / perPage()));
      if (next !== pageCount) {
        pageCount = next;
        buildDots();
      }
      page = Math.min(page, pageCount - 1);
      paint();
    };

    const tick = () => {
      if (!paused && visible) go(page + 1);
    };

    const restart = () => {
      clearInterval(timer);
      if (!reduced) timer = setInterval(tick, AUTOPLAY_MS);
    };

    root.querySelector('[data-elin-prev]')?.addEventListener('click', () => go(page - 1, true));
    root.querySelector('[data-elin-next]')?.addEventListener('click', () => go(page + 1, true));

    root.addEventListener('pointerenter', () => {
      paused = true;
    });
    root.addEventListener('pointerleave', () => {
      paused = false;
    });
    root.addEventListener('focusin', () => {
      paused = true;
    });
    root.addEventListener('focusout', () => {
      paused = false;
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.2 }).observe(root);
    }

    window.addEventListener('resize', measure);
    measure();
    restart();
  });
})();
